import { FlexRow, MaterialIcon, StyledButton, StyledSearchBar, useModal } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { memo, useEffect } from 'react';
import { useStyles } from '../../../hooks/useStyles';
import { StyledTooltip } from '../../ui/StyledTooltip';
import useFleetMaintenanceRules from '../hooks/useFleetMaintenanceRules';
import FleetMaintenanceRuleModal from './FleetMaintenanceRuleModal';
import { FleetMaintenanceRulesFilters } from './FleetMaintenanceRulesFilters';

function FleetMaintenanceRulesFiltersBar() {
  const { css, theme } = useStyles();
  const { closeModal, openModal, showModal } = useModal();
  const { hasActiveFilters, onChangeSearch, onReload, resetAllFilters, resetFilters, search } =
    useFleetMaintenanceRules();

  useEffect(() => {
    return () => {
      resetAllFilters();
    };
  }, []);

  return (
    <FlexRow
      classNames={css({ alignItems: 'center' })}
      gap={theme.sizing.scale100}
    >
      <FlexRow
        classNames={css({ flex: '1', alignItems: 'center' })}
        gap={theme.sizing.scale100}
      >
        <span className={css({ flexGrow: '0.5' })}>
          <StyledSearchBar
            name="fleet-maintenance-configuration-search"
            value={search}
            onChange={onChangeSearch}
            clearable
            noMargin
          />
        </span>
        <FleetMaintenanceRulesFilters />
        <StyledTooltip
          content="Limpiar filtros"
          showArrow={false}
        >
          <Button
            size="mini"
            shape="round"
            onClick={resetFilters}
            kind="tertiary"
            disabled={!hasActiveFilters}
          >
            <MaterialIcon
              name="clear"
              size="mini"
              color={!hasActiveFilters ? theme.colors.contentStateDisabled : undefined}
            />
          </Button>
        </StyledTooltip>
      </FlexRow>
      <StyledTooltip
        content="Recargar tabla"
        showArrow={false}
      >
        <Button
          size="compact"
          shape="square"
          onClick={onReload}
          kind="tertiary"
        >
          <MaterialIcon name="refresh" />
        </Button>
      </StyledTooltip>
      <StyledButton
        onClick={openModal}
        startEnhancer={
          <MaterialIcon
            name="add"
            size={theme.sizing.scale600}
            color={theme.colors.contentInversePrimary}
          />
        }
      >
        Nueva regla
      </StyledButton>
      <FleetMaintenanceRuleModal
        isOpen={showModal}
        onClose={(update) => {
          if (update) onReload();
          closeModal();
        }}
      />
    </FlexRow>
  );
}

export default memo(FleetMaintenanceRulesFiltersBar);
